export const PARTNER_LOAD = 'PARTNER_LOAD';
export const UPDATE = 'UPDATE';
export const CLEAR = 'CLEAR';
export const SET_PAGES = 'SET_PAGES';
export const SET_W9 = 'SET_W9';
export const SET_SELECTED_PAGE = 'SET_SELECTED_PAGE';
